module.exports = require('./lib//PublicAPI')




/** WEBPACK FOOTER **
 ** /Users/ryanflorence/Code/github/ryanflorence/react-project/index.js
 **/